import { TooltipProvider_default as e } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_da296058102805d3e82696b7a23dd27c/node_modules/reka-ui/dist/Tooltip/TooltipProvider.js";
import { createBlock as t, defineComponent as n, guardReactiveProps as r, normalizeProps as i, openBlock as a, renderSlot as o, unref as s, withCtx as c } from "vue";
//#region src/components/ui/tooltip/core/TooltipProvider.vue?vue&type=script&setup=true&lang.ts
var l = /* @__PURE__ */ n({
	__name: "TooltipProvider",
	props: {
		delayDuration: { default: 0 },
		skipDelayDuration: {},
		disableHoverableContent: { type: Boolean },
		disableClosingTrigger: { type: Boolean },
		disabled: { type: Boolean },
		ignoreNonKeyboardFocus: { type: Boolean }
	},
	setup(n) {
		let l = n;
		return (n, u) => (a(), t(s(e), i(r(l)), {
			default: c(() => [o(n.$slots, "default")]),
			_: 3
		}, 16));
	}
});
//#endregion
export { l as default };

//# sourceMappingURL=TooltipProvider_vue.js.map